import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable, TemplateRef } from '@angular/core';

import { SlotId } from './slot.types';

@Injectable({ providedIn: 'root' })
export class SlotService {
  private readonly slots = new Map<SlotId, BehaviorSubject<TemplateRef<unknown> | null>>();

  public show(id: SlotId, template: TemplateRef<unknown>): void {
    this.getSubject(id).next(template);
  }

  public hide(id: SlotId): void {
    this.getSubject(id).next(null);
  }

  public asObservable(id: SlotId): Observable<TemplateRef<unknown> | null> {
    return this.getSubject(id);
  }

  private getSubject(id: SlotId): BehaviorSubject<TemplateRef<unknown> | null> {
    if (!this.slots.has(id)) {
      this.slots.set(id, new BehaviorSubject<TemplateRef<unknown> | null>(null));
    }
    return this.slots.get(id)!;
  }
}
